import React, { useEffect } from "react";
import { EditPieceStepProps } from "../dashboardEditPiece";
import OptionChooser from "../../../../components/optionChooser";
import { PieceDTO } from "../../../../openapi-generated-client";
import EditPieceStepAddButton from "./components/editPieceStepAddButton";
import { useDashboardContext } from "../../../../context/dashboardContext";
import { getApiUrl } from "../../../../data/api/apiManager";
import { EditPieceScoresProps } from "./editPieceScores";
import * as pdfjsLib from "pdfjs-dist";
import TextFieldDropdown from "../../../../components/textField/textFieldDropdown";
import XIcon from "../../../../assets/icons/xIcon";
import { count } from "console";

export default function EditPiecePreview(props: EditPieceScoresProps) {

    const {sessionId, appContext} = useDashboardContext();
    const {assetController} = appContext;

    const [previewPreview, setPreviewPreview] = React.useState<string | undefined>(undefined);
    const [pdfPreview, setPdfPreview] = React.useState<string | undefined>("");

    const [pageCount, setPageCount] = React.useState(0);
    const [scoreArrayBuffer, setScoreArrayBuffer] = React.useState<ArrayBuffer | undefined>(undefined);

    function getMessage(data: PieceDTO) {
        if((data.thumbnailHash === undefined || data.thumbnailHash === "") && data.customThumbnail) {
            return "Your custom thumbnail cannot be empty";
        }
        return "";
    }

    async function generatePDFPreviewOfPreview() {
        if(props.piece.previewHash == undefined) {
            console.log("No preview hash, cannot load preview");
            return;
        }
        let arrayBuffer;
        const response = await fetch(getApiUrl("assets/by-hash/" + props.piece.previewHash));
  
        if (!response.ok) {
            throw new Error(`Failed to fetch file: ${response.statusText}`);
        }
        
        arrayBuffer = await response.arrayBuffer();
        // Load the PDF document using PDF.js
        const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;const canvas = document.createElement("canvas");
        const page = await pdf.getPage(1);
        const context = canvas.getContext("2d");

        if (!context) return;

        // Set the canvas dimensions to match the PDF page viewport
        const viewport = page.getViewport({ scale: 1 }); // Adjust scale here
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        // Render the page onto the canvas
        const renderContext = {
            canvasContext: context,
            viewport: viewport,
            canvas: canvas,
        };
        await page.render(renderContext).promise;

        // Convert the canvas to a data URL
        setPreviewPreview(canvas.toDataURL("image/png"));
    }

    async function loadScoreArrayBuffer() {
        let arrayBuffer;
        if(props.scores.length == 0) {
            console.log("No scores, cannot generate preview");
            return undefined;
        }
        if(props.scores[0].file && props.scores[0].file instanceof File && props.scores[0].file.type == "application/pdf") {
            arrayBuffer = await props.scores[0].file.arrayBuffer();
            
        }else {
            const response = await fetch(getApiUrl("assets/by-hash/" + props.scores[0].fileHash));
  
            if (!response.ok) {
                throw new Error(`Failed to fetch file: ${response.statusText}`);
            }
            
            arrayBuffer = await response.arrayBuffer();
        }
        setScoreArrayBuffer(arrayBuffer);
    }

    useEffect(() => {
        props.setStepMessage(getMessage(props.piece));
    }, [props.piece]);
    

    useEffect(() => {
        loadScoreArrayBuffer();
    }, [props.scores, props.piece]);

    useEffect(() => {
        countPages();
        async function callGeneration() {
            setPdfPreview(await generatePDFPreview());
        }
        callGeneration();
    }, [scoreArrayBuffer])

    useEffect(() => {
        generatePDFPreviewOfPreview();
    }, [props.piece.previewHash || props.piece.previewPageCount]);

    async function countPages() {

        
        if(scoreArrayBuffer == undefined) {
            console.log("No score array buffer, cannot count pages");
            return;
        }
        const clonedBuffer = scoreArrayBuffer.slice(0);
        const uint8Array = new Uint8Array(clonedBuffer);
        const pdf = await pdfjsLib.getDocument({ data: uint8Array }).promise;
        setPageCount(pdf.numPages);

    }

    const allPreviewablePages: string[] = [];
    for(let i = 1; i <= pageCount; i++) {
        allPreviewablePages.push(i.toString());
    }

    async function generatePDFPreview() {

        
        if(scoreArrayBuffer == undefined) {
            console.log("No score array buffer, cannot generate preview");
            return;
        }
        
        const clonedBuffer = scoreArrayBuffer.slice(0);
        const uint8Array = new Uint8Array(clonedBuffer);

        // Load the PDF document using PDF.js
            const pdf = await pdfjsLib.getDocument({ data: uint8Array }).promise;const canvas = document.createElement("canvas");
            const page = await pdf.getPage(props.piece.generateThumbnailFromPage || 1);
            const context = canvas.getContext("2d");

            if (!context) return;

            // Set the canvas dimensions to match the PDF page viewport
            const viewport = page.getViewport({ scale: 1 }); // Adjust scale here
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            // Render the page onto the canvas
            const renderContext = {
                canvasContext: context,
                viewport: viewport,
                canvas: canvas,
            };
            await page.render(renderContext).promise;

            // Convert the canvas to a data URL
            return canvas.toDataURL("image/png");
    }

    async function updatePreview(files: File[]) {
        const file = files[0];

        var body = new FormData()
        body.append('scoreFile', file, file.name);
        const response = await fetch(getApiUrl("score/preview"), {
            method: "PUT",
            headers: {
                "authorization": sessionId
            },
            body: body
        });
        const data = await response.json();
        if(response.status == 200) {
            props.setPiece({...props.piece, previewHash: data.contentHash});
        }else {
            window.location.href = "/error/1";
        }
    }

    async function updateThumbnail(files: File[]) {
        const file = files[0];

        var body = new FormData()
        body.append('file', file, file.name);
        body.append('assetCreateDTO', new Blob([
            JSON.stringify({
                altText: "Thumbnail for piece " + props.piece.title,
            })
        ], {
            type: "application/json"
        }));
        const response = await fetch(getApiUrl("assets"), {
            method: "POST",
            headers: {
                "authorization": sessionId
            },
            body: body
        });
        const data = await response.json();
        if(response.status == 201) {
            props.setPiece({...props.piece, thumbnailHash: data.contentHash});
        }else {
            window.location.href = "/error/1";
        }
    }

    return <>
        <div className="thumbnail-title-section">
            <h2>Thumbnail</h2>
            <p className="quotation">Change the first image that represents your piece.</p>
            {props.piece.externalScoreLink == undefined && 
            <OptionChooser options={["Use Page", "Upload Different Image"]} active={!props.piece.customThumbnail ? "Use Page" : "Upload Different Image"} setActive={(v: string) => {
                if(v == "Use Page") {
                    props.setPiece({...props.piece, thumbnailHash: undefined, customThumbnail: false, generateThumbnailFromPage: 1});
                }else {
                    props.setPiece({...props.piece, customThumbnail: true, thumbnailHash: undefined});
                }
            }}/>}
            {!props.piece.customThumbnail && <TextFieldDropdown suffix="to generate Thumbnail" title="Select a page" label="Use page" options={allPreviewablePages} active={props.piece.generateThumbnailFromPage ? props.piece.generateThumbnailFromPage.toString() : allPreviewablePages[0]} setActive={(v: string) => {
                props.setPiece({...props.piece, generateThumbnailFromPage: v.length > 0 ? Number(v) : undefined});
            }}/>}
            {(props.piece.thumbnailHash || !props.piece.customThumbnail) && <div className="thumbnail-preview">
                {props.piece.customThumbnail && <div className="remove-thumbnail" onClick={() => {
                    props.setPiece({...props.piece, thumbnailHash: undefined});
                }}><XIcon/></div>}
                <img src={props.piece.customThumbnail ? getApiUrl("assets/by-hash/" + props.piece.thumbnailHash) : pdfPreview} className="piece-thumbnail-preview"/>
                
            </div>}
        </div>
        {(props.piece.customThumbnail && props.piece.thumbnailHash == undefined) && <EditPieceStepAddButton onDrop={updateThumbnail} onClick={() => {
            const fileInput = document.createElement('input');
            fileInput.type = 'file';

            fileInput.addEventListener('change', async function(event) {
                if (!event.target) return;
                const selectedFiles = (event.target as HTMLInputElement).files;
                if (selectedFiles) {
                    await updateThumbnail(Array.from(selectedFiles));
                }
            });

            // Trigger the file input programmatically
            fileInput.click();
        }}>Click or Drag to Upload</EditPieceStepAddButton>}

        <div className="section-placeholder"/>

        <h2>Preview</h2>
        {props.piece.externalScoreLink != undefined ? <>
        
            <p className="quotation">Add an additional PDF file for preview of your piece. We add a watermark to protect all preview pages.</p>
            
            {(props.piece.previewHash) && <div className="thumbnail-preview">
                <div className="remove-thumbnail" onClick={() => {
                    props.setPiece({...props.piece, previewHash: undefined});
                }}><XIcon/></div>
                <img src={previewPreview} className="piece-thumbnail-preview"/>
                
            </div>}
            
            {props.piece.previewHash == undefined && <EditPieceStepAddButton onDrop={updatePreview} onClick={() => {
                const fileInput = document.createElement('input');
                fileInput.type = 'file';

                fileInput.addEventListener('change', async function(event) {
                    if (!event.target) return;
                    const selectedFiles = (event.target as HTMLInputElement).files;
                    if (selectedFiles && selectedFiles.length > 0) {
                        updatePreview(Array.from(selectedFiles));
                    } else {
                        console.log("No file selected");
                    }
                });

                // Trigger the file input programmatically
                fileInput.click();
            }}>Click or Drag to Upload</EditPieceStepAddButton>}

        </> : <>

        <p className="quotation">Add more pages, so people can preview your piece. We add a watermark to protect all preview pages.</p>
            
        <TextFieldDropdown suffix="Pages of the Main Score Page" title="Select the page" label="Preview a first" options={allPreviewablePages} active={props.piece.previewPageCount ? props.piece.previewPageCount.toString() : allPreviewablePages[0]} setActive={(v: string) => {
                props.setPiece({...props.piece, previewPageCount: v.length > 0 ? Number(v) : undefined});
            }}/>

        </>}
    </>;
}